import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgResetPasswordIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			id: "Illustrations-1",
			clipPath: "url(#clip0_145_2709)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					id: "Ellipse 121",
					cx: 30,
					cy: 30,
					r: 30,
					fill: "#F0FAF8"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M38.5714 25.5H21.4286C19.535 25.5 18 26.9775 18 28.8V38.7C18 40.5225 19.535 42 21.4286 42H38.5714C40.465 42 42 40.5225 42 38.7V28.8C42 26.9775 40.465 25.5 38.5714 25.5Z",
					stroke: "#6BCABA",
					strokeWidth: 3,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M30 35.25C31.2426 35.25 32.25 34.2426 32.25 33C32.25 31.7574 31.2426 30.75 30 30.75C28.7574 30.75 27.75 31.7574 27.75 33C27.75 34.2426 28.7574 35.25 30 35.25Z",
					stroke: "#865E9C",
					strokeWidth: 3,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_3",
					d: "M23.25 25.5V21.7083C23.25 19.9292 23.9612 18.2229 25.227 16.9648C26.4929 15.7068 28.2098 15 30 15C31.7902 15 33.5071 15.7068 34.773 16.9648C36.0388 18.2229 36.75 19.9292 36.75 21.7083V25.5",
					stroke: "#6BCABA",
					strokeWidth: 3,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_145_2709",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 60,
				height: 60,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgResetPasswordIcon);
export { ForwardRef as ReactComponent };
